module.exports = __webpack_public_path__ + "static/media/oberflex-movinguimoire-1200x2490.73ff991f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-movinguimoire-1200x2490.jpg
// module id = 1034
// module chunks = 37